import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class AddContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: null, // Allow textInput to be null for optional image
      userName: "",
      category: "", // Add a category state
      submissionStatus: null,
      currentImageUrl: null,
      submeet: false,
      errors: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
    };
  }

  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
        });
      }
    });

    this.setState({ errors });
  };

  handleCategoryChange = (e) => {
    this.setState({ category: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submeet: true });

    const { textInput, userName, category } = this.state;

    // Check that userName and category are provided
    if (!userName || !category) {
      return; 
    }

    try {
      const formData = new FormData();
      if (textInput) {
        formData.append('image', textInput); // Append image only if it exists
      }
      formData.append('name', userName);
      formData.append('category', category); // Append category

      const response = await axios.post("https://samaj.aasmo.in/api/admin/add", formData, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });

      if (response.status === 201) {
        this.setState({ submissionStatus: 'success', submeet: false });
        setTimeout(() => {
          this.props.history.push("/list-content");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { textInput, userName, category, submeet, currentImageUrl, submissionStatus } = this.state;
    const isNameValid = userName.trim().length > 0;
    const isCategoryValid = category.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Add Content</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Image (Optional)</label>
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!textInput && submeet}`}
                  name="textInput"
                  onChange={this.handleChange}
                />
              </div>

              <div className="form-group">
                <label>Category</label>
                <input
                  className={`form-control ${!isCategoryValid && submeet && "parsley-error"}`}
                  value={category}
                  name="category"
                  required
                  type="text"
                  onChange={this.handleCategoryChange}
                />
                {!isCategoryValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Content</label>
                <input
                  className={`form-control ${!isNameValid && submeet && "parsley-error"}`}
                  value={userName}
                  name="userName"
                  required
                  type="text"
                  onChange={(e) => {
                    this.setState({ userName: e.target.value });
                  }}
                />
                {!isNameValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, { notifyGeneralInfo })(AddContent));
